module.exports = __webpack_public_path__ + "assets/8da6d50b33f9a9566fa2f35f227712d8.mp3";